export const INITIAL_SIZE = { width: 270, height: 240 };
export const MIN_SIZE = { width: 270, height: 140 };
export const MAX_SIZE = { width: 600, height: 800 };
